import React from 'react';

let Toolbar = (props) => {
    return (
        <div id='toolbar'>
            {props.text}
        </div>
    )
}

export default Toolbar;